import { generateClient, isCancelError } from "aws-amplify/api";
import { hasEmptyCallbackUrlAtEnd } from "../../Utils";

const client = generateClient();

export async function requestListTransaction(dispatch, payload) {
  try {
    const {
      page,
      status,
      limit = 10,
      createdAt = "",
      sortDirection = "DESC",
      nextToken = null,
      userID,
    } = payload;

    dispatch({
      type: "REQUEST_LIST_TRANSACTION",
      payload: { request: null, page },
    });

    const params = {
      status,
      limit,
      sortDirection,
      nextToken,
      userID,
    };

    if (createdAt) params.createdAt = createdAt;

    const request = client.graphql({
      query: transactionsbyUserIDCreatedAt,
      variables: params,
    });

    dispatch({
      type: "REQUEST_LIST_TRANSACTION",
      payload: { request, page },
    });

    const res = await request;

    const { items, nextToken: token } = res.data.transactionsbyUserIDCreatedAt;
    const nextPage = page + 1;

    dispatch({
      type: "LIST_TRANSACTION_SUCCESS",
      payload: { items, nextToken: token, nextPage },
    });
  } catch (error) {
    if (isCancelError(error)) {
      dispatch({
        type: "LIST_TRANSACTION_CANCEL",
      });
    } else {
      dispatch({ type: "LIST_TRANSACTION_ERROR", error });
    }
  }
}

export async function requestGetTransaction(dispatch, payload) {
  try {
    const { id, silent = false } = payload;

    dispatch({
      type: silent ? "REQUEST_REFRESH_TRANSACTION" : "REQUEST_GET_TRANSACTION",
    });

    const params = {
      id,
    };

    const res = await client.graphql({
      query: getTransaction,
      variables: params,
    });

    const transaction = res.data.getTransaction;

    if (!transaction) {
      throw new Error("Transaction not found.");
    }

    // Parse actions
    let actions = [];
    if (transaction.actions) {
      try {
        actions = JSON.parse(transaction.actions);
        actions.forEach((action) => {
          if (action.name === "generate-qr-code") {
            transaction.redirect = action.url;
          }
          if (action.name === "redirect") {
            transaction.redirect = action.url;
          }
          if (
            action.name === "deeplink-redirect" &&
            transaction.paymentType === "gopay"
          ) {
            if (hasEmptyCallbackUrlAtEnd(action.url)) {
              transaction.gopay = `${action.url}https://web.pajakind.com/transaction/${transaction.id}`;
            } else {
              transaction.gopay = action.url;
            }
          }
          if (action.name === "mandiri-bill") {
            transaction.mandiriBill = {
              billerCode: action.biller_code,
              billKey: action.bill_key,
            };
          }
        });
      } catch (error) {
        actions = [];
      }
    }
    transaction.actions = actions;

    // Parse products
    let products = [];
    if (transaction.products) {
      try {
        transaction.products.forEach((product) => {
          if (product.productSnapshot) {
            products.push(JSON.parse(product.productSnapshot));
          }
        });
      } catch (error) {
        products = [];
      }
    }
    transaction.products = products;

    dispatch({
      type: "GET_TRANSACTION_SUCCESS",
      payload: { transaction },
    });
  } catch (error) {
    dispatch({
      type: payload.silent
        ? "REFRESH_TRANSACTION_ERROR"
        : "GET_TRANSACTION_ERROR",
      error,
    });
  }
}

const transactionsbyUserIDCreatedAt = /* GraphQL */ `
  query TransactionsbyUserIDCreatedAt(
    $userID: ID
    $createdAt: ModelStringKeyConditionInput
    $sortDirection: ModelSortDirection
    $filter: ModelTransactionFilterInput
    $limit: Int
    $nextToken: String
  ) {
    transactionsbyUserIDCreatedAt(
      userID: $userID
      createdAt: $createdAt
      sortDirection: $sortDirection
      filter: $filter
      limit: $limit
      nextToken: $nextToken
    ) {
      items {
        id
        status
        orderType
        totalPay
        paymentType
        paymentNumber
        paymentDestinationName
        voucher
        totalDiscount
        discounts {
          id
          type
          title
          description
          total
        }
        actions
        products {
          productType
          productId
          productSnapshot
          price
        }
        userID
        description
        createdAt
        updatedAt
        expiredAt
      }
      nextToken
    }
  }
`;

const getTransaction = /* GraphQL */ `
  query GetTransaction($id: ID!) {
    getTransaction(id: $id) {
      id
      status
      orderType
      totalPay
      paymentType
      paymentNumber
      paymentDestinationName
      voucher
      totalDiscount
      discounts {
        id
        type
        title
        description
        total
      }
      actions
      products {
        productType
        productId
        productSnapshot
        price
      }
      userID
      description
      updatedAt
      expiredAt
      createdAt
    }
  }
`;
